import React from 'react'
import './CardScroll.css'

  
function CardScroll({title,imageUrl,body}){
    return( 
        <article className='cardscroll reveal'>
                <picture className='thumbnail'>
                    <img src={imageUrl} alt= ''/>
                </picture>
                <div className='cardscroll-text'>
                    <p id="cardtitle">{title}</p>
                </div>               
                <div className='cardscroll-content'>
                    <p>{body}</p>
                </div>

        </article>
    )
}

window.addEventListener('scroll', reveal);

function reveal(){
  var reveals = document.querySelectorAll('.reveal');

  for(var i = 0; i < reveals.length; i++){

    var windowheight = window.innerHeight;
    var revealtop = reveals[i].getBoundingClientRect().top;
    var revealpoint = 150;

    if(revealtop < windowheight - revealpoint){
      reveals[i].classList.add('active');
    }
    else{
      reveals[i].classList.remove('active');
    }
  }
}

export default CardScroll